export function useDebounceFunction(fn: any, delay: number) {
  let timeoutId: any;
  function debounced(...args: any) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      fn(...args);
    }, delay);
  }
  return debounced;
}